import React from 'react';
import Home from '../Home';
import AdsImg from "../../img/googleAds.png"
import LandingPage from "../../img/mehar.png"

// Reusable SVG Icon Components
const MegaphoneIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="w-12 h-12 mb-4 text-white"
  >
    <path
      fillRule="evenodd"
      d="M6.25 4.5a1.5 1.5 0 0 1 1.5-1.5h10.5a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-1.5a.75.75 0 0 0-.75.75v3.75a.75.75 0 0 1-1.5 0V11.25a.75.75 0 0 0-.75-.75h-1.5a1.5 1.5 0 0 1-1.5-1.5V4.5Zm1.5 0V3.75h1.5v3.75h-1.5v-3Z"
      clipRule="evenodd"
    />
    <path d="M11.25 15.75a1.5 1.5 0 0 0-1.5-1.5H3.75a1.5 1.5 0 0 0-1.5 1.5v3a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5v-3Z" />
    <path
      fillRule="evenodd"
      d="M19.5 7.5a1.5 1.5 0 0 0-1.5-1.5h-1.5v-1.5h-1.5v1.5h-1.5v-1.5h-1.5v1.5h-1.5v-1.5h-1.5v1.5h-1.5v-1.5h-1.5v1.5h-1.5v-1.5h-1.5v1.5h-1.5v-1.5H7.5V6H6a1.5 1.5 0 0 0-1.5 1.5v3a1.5 1.5 0 0 0 1.5 1.5h13.5a1.5 1.5 0 0 0 1.5-1.5v-3Z"
      clipRule="evenodd"
    />
  </svg>
);

const RocketIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-12 h-12 mb-4 text-white"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.5 8.25V6.75C10.5 5.92157 11.1716 5.25 12 5.25H13.5C14.3284 5.25 15 5.92157 15 6.75V8.25"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 18V12"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.25 10.5H9.75"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15 15.75a3.75 3.75 0 0 1-7.5 0"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 12a3.75 3.75 0 0 1 7.5 0V15a3.75 3.75 0 0 1-7.5 0V12Z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4.5 12a7.5 7.5 0 0 1 7.5-7.5"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 19.5a7.5 7.5 0 0 1-7.5-7.5"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 4.5a7.5 7.5 0 0 1 7.5 7.5"
    />
  </svg>
);

const MagnifyingGlassIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-12 h-12 mb-4 text-white"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
    />
  </svg>
);

const CheckCircleIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="w-6 h-6 text-green-500"
  >
    <path
      fillRule="evenodd"
      d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.882l-3.484 4.195-1.958-1.594a.75.75 0 0 0-1.223.806l2.508 2.507a.75.75 0 0 0 1.135-.075l4.04-4.524Z"
      clipRule="evenodd"
    />
  </svg>
);

const UserGroupIcon = (props) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="w-12 h-12 mb-4 text-white"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17.982 18.725A7.5 7.5 0 0 0 20.25 12a7.5 7.5 0 0 0-7.5-7.5c-.725 0-1.442.122-2.115.352m-.83 1.952c-2.28-.621-4.63-1.077-7.005-.985"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 18.75a7.5 7.5 0 0 0 7.5-7.5m-7.5 7.5a7.5 7.5 0 0 1-7.5-7.5m7.5 7.5v1.5m-4.5-6a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z"
    />
  </svg>
);

function CampaignLeadGeneration() {
  return (
    <Home>
    <div className="min-h-screen bg-gray-50 font-sans text-gray-800 antialiased">
      {/* Tailwind CSS is assumed to be available. */}
      <script src="https://cdn.tailwindcss.com"></script>
      <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap" />
      <style>{`body { font-family: 'Inter', sans-serif; }`}</style>

      {/* Hero Section */}
      <header className="bg-gradient-to-br from-blue-600 to-blue-800 text-white py-16 px-4 sm:px-6 lg:px-8 shadow-xl">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight mb-4">
            Grow Your Clinic with Effective Digital Campaigns
          </h1>
          <p className="text-lg sm:text-xl lg:text-2xl font-light mb-8 max-w-3xl mx-auto">
            Reach new patients, build your reputation, and manage your marketing with our all-in-one lead generation platform.
          </p>
          <button className="bg-white text-blue-600 font-semibold px-8 py-3 rounded-full shadow-lg hover:bg-gray-100 transition-transform transform hover:scale-105">
            Get a Free Marketing Plan
          </button>
        </div>
      </header>

      {/* Benefits Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold text-center mb-12">How Our Platform Drives Growth</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 text-center transform transition-transform hover:scale-105 hover:shadow-2xl">
              <div className="mx-auto w-24 h-24 bg-blue-500 rounded-full flex items-center justify-center mb-6">
                <MegaphoneIcon />
              </div>
              <h3 className="text-xl font-semibold mb-2">Attract the Right Patients</h3>
              <p className="text-gray-600">
                Target your ideal patient demographic with precision advertising on social media and search engines.
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 text-center transform transition-transform hover:scale-105 hover:shadow-2xl">
              <div className="mx-auto w-24 h-24 bg-teal-500 rounded-full flex items-center justify-center mb-6">
                <RocketIcon />
              </div>
              <h3 className="text-xl font-semibold mb-2">Automate Your Lead Funnel</h3>
              <p className="text-gray-600">
                From initial contact to appointment booking, our system automates the process to save you time and effort.
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 text-center transform transition-transform hover:scale-105 hover:shadow-2xl">
              <div className="mx-auto w-24 h-24 bg-pink-500 rounded-full flex items-center justify-center mb-6">
                <MagnifyingGlassIcon />
              </div>
              <h3 className="text-xl font-semibold mb-2">Analyze Your Results</h3>
              <p className="text-gray-600">
                Track the performance of your campaigns with intuitive dashboards and detailed reports to optimize for success.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Campaign Showcase */}
      <section className="bg-gray-100 py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">Integrated Campaign Tools</h2>
          <p className="text-lg text-gray-600 mb-12 max-w-2xl mx-auto">
            Our platform provides a seamless, integrated experience across both desktop and mobile devices.
          </p>
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div className="rounded-2xl shadow-xl overflow-hidden border border-gray-200">
              <img
                src={AdsImg}
                alt="Engaging Landing Page"
                className="w-full h-auto"
              />
            </div>
            <div className="rounded-2xl shadow-xl overflow-hidden border border-gray-200">
              <img
                src={LandingPage}
                alt="Social Media Ad Preview"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">Simple, Scalable Plans</h2>
          <p className="text-lg text-gray-600 mb-12">
            Choose the plan that fits your growth goals, with no hidden fees and the flexibility to upgrade anytime.
          </p>
          <div className="grid md:grid-cols-3 gap-8">
            {/* Essential Plan */}
            <div className="flex flex-col bg-white rounded-2xl shadow-lg border border-gray-200 p-8 transform transition-transform hover:scale-105 hover:shadow-2xl">
              <div className="flex-grow">
                <div className="mx-auto w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mb-4">
                  <UserGroupIcon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold mb-2">Essential</h3>
                <p className="text-gray-600 mb-4">Start your digital presence.</p>
                <p className="text-4xl font-extrabold mb-6">₹5000<span className="text-xl font-medium text-gray-500">/mo</span></p>
                <ul className="text-left space-y-3 mb-8">
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />1-Page Lead Funnel</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Google Business Profile Opt.</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Basic SEO for Local Search</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Email & SMS Capture</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Monthly Performance Reports</li>
                </ul>
              </div>
              <button className="w-full bg-blue-600 text-white font-semibold py-3 rounded-full shadow-md hover:bg-blue-700 transition-colors">
                Select Essential Plan
              </button>
            </div>
            {/* Growth Pro Plan */}
            <div className="flex flex-col bg-white rounded-2xl shadow-lg border-2 border-blue-600 p-8 transform transition-transform hover:scale-105 hover:shadow-2xl relative">
              <span className="absolute top-0 right-0 -mt-3 -mr-3 bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg">Most Popular</span>
              <div className="flex-grow">
                <div className="mx-auto w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mb-4">
                  <UserGroupIcon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold mb-2">Growth Pro</h3>
                <p className="text-gray-600 mb-4">Accelerate your patient acquisition.</p>
                <p className="text-4xl font-extrabold mb-6">₹9999<span className="text-xl font-medium text-gray-500">/mo</span></p>
                <ul className="text-left space-y-3 mb-8">
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Everything in Essential</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Social Media Ad Campaigns</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Automated Email Nurturing</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Patient Referral Program</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Advanced Conversion Tracking</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Dedicated Marketing Specialist</li>
                </ul>
              </div>
              <button className="w-full bg-blue-600 text-white font-semibold py-3 rounded-full shadow-md hover:bg-blue-700 transition-colors">
                Select Growth Pro
              </button>
            </div>
            {/* Enterprise Plan */}
            <div className="flex flex-col bg-white rounded-2xl shadow-lg border border-gray-200 p-8 transform transition-transform hover:scale-105 hover:shadow-2xl">
              <div className="flex-grow">
                <div className="mx-auto w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mb-4">
                  <UserGroupIcon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl font-bold mb-2">Enterprise</h3>
                <p className="text-gray-600 mb-4">For large clinics with multiple locations.</p>
                <p className="text-4xl font-extrabold mb-6">Contact Us</p>
                <ul className="text-left space-y-3 mb-8">
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Everything in Growth Pro</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Custom Google Ads Management</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Local SEO for all Locations</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />Quarterly Strategy Sessions</li>
                  <li className="flex items-center"><CheckCircleIcon className="mr-2" />24/7 Priority Support</li>
                </ul>
              </div>
              <button className="w-full bg-blue-600 text-white font-semibold py-3 rounded-full shadow-md hover:bg-blue-700 transition-colors">
                Contact Sales
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Features List */}
      <section className="bg-white py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold text-center mb-12">Key Features for Your Marketing</h2>
          <div className="grid md:grid-cols-2 gap-12">
            <div className="bg-gray-100 p-8 rounded-2xl shadow-lg transform transition-transform hover:scale-105 hover:shadow-2xl flex items-start space-x-4">
              <div className="flex-shrink-0 mt-1">
                <CheckCircleIcon className="text-blue-500 w-8 h-8" />
              </div>
              <div>
                <h3 className="text-2xl font-semibold mb-2">Patient Persona Creation</h3>
                <p className="text-gray-600">
                  We help you define your ideal patient to create highly targeted campaigns that resonate.
                </p>
              </div>
            </div>
            <div className="bg-gray-100 p-8 rounded-2xl shadow-lg transform transition-transform hover:scale-105 hover:shadow-2xl flex items-start space-x-4">
              <div className="flex-shrink-0 mt-1">
                <CheckCircleIcon className="text-blue-500 w-8 h-8" />
              </div>
              <div>
                <h3 className="text-2xl font-semibold mb-2">Lead Tracking and Nurturing</h3>
                <p className="text-gray-600">
                  Monitor every lead's journey from their first click to their booked appointment in a centralized dashboard.
                </p>
              </div>
            </div>
            <div className="bg-gray-100 p-8 rounded-2xl shadow-lg transform transition-transform hover:scale-105 hover:hover:shadow-2xl flex items-start space-x-4">
              <div className="flex-shrink-0 mt-1">
                <CheckCircleIcon className="text-blue-500 w-8 h-8" />
              </div>
              <div>
                <h3 className="text-2xl font-semibold mb-2">Social Media Management</h3>
                <p className="text-gray-600">
                  Build a community and increase engagement with a professionally managed social media presence.
                </p>
              </div>
            </div>
            <div className="bg-gray-100 p-8 rounded-2xl shadow-lg transform transition-transform hover:scale-105 hover:shadow-2xl flex items-start space-x-4">
              <div className="flex-shrink-0 mt-1">
                <CheckCircleIcon className="text-blue-500 w-8 h-8" />
              </div>
              <div>
                <h3 className="text-2xl font-semibold mb-2">Reputation Management</h3>
                <p className="text-gray-600">
                  Collect and showcase positive patient reviews to build trust and authority in your local market.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">Success Stories from Our Clients</h2>
          <p className="text-lg text-gray-600 mb-12 max-w-2xl mx-auto">
            See how other clinics are growing their practices with our help.
          </p>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-200 text-center">
              <p className="text-lg italic text-gray-700 mb-4">
                "Our clinic saw a 40% increase in new patient inquiries within the first three months. The targeted campaigns are incredibly effective."
              </p>
              <p className="font-semibold text-blue-600">- Dr. Michael Chen</p>
              <p className="text-sm text-gray-500">Orthopedic Surgeon</p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-200 text-center">
              <p className="text-lg italic text-gray-700 mb-4">
                "The automated follow-up system has been a game-changer. We're converting more leads into appointments than ever before."
              </p>
              <p className="font-semibold text-blue-600">- Dr. Sarah Jones</p>
              <p className="text-sm text-gray-500">Pediatrician</p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-200 text-center">
              <p className="text-lg italic text-gray-700 mb-4">
                "The team's expertise in healthcare marketing is unmatched. They helped us identify and reach a new patient demographic we weren't reaching before."
              </p>
              <p className="font-semibold text-blue-600">- Dr. David Lee</p>
              <p className="text-sm text-gray-500">Dermatologist</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="bg-white py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl sm:text-4xl font-bold text-center mb-12">Common Marketing Questions</h2>
          <div className="space-y-6">
            <div className="p-6 bg-gray-100 rounded-lg shadow-sm">
              <h3 className="text-xl font-semibold text-gray-800 mb-2">How long will it take to see results?</h3>
              <p className="text-gray-600">
                While initial results can be seen in the first 30 days, most clients see significant growth and ROI within 3-6 months as campaigns are optimized and scaled.
              </p>
            </div>
            <div className="p-6 bg-gray-100 rounded-lg shadow-sm">
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Do you handle social media content creation?</h3>
              <p className="text-gray-600">
                Yes, our Growth Pro and Enterprise plans include content strategy and creation for your social media channels to ensure a consistent and professional brand voice.
              </p>
            </div>
            <div className="p-6 bg-gray-100 rounded-lg shadow-sm">
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Can you target specific medical conditions?</h3>
              <p className="text-gray-600">
                Absolutely. Our advanced targeting capabilities allow us to create campaigns for specific specialties, services, or patient needs while adhering to privacy regulations.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="bg-blue-600 text-white py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">Ready to Grow Your Patient Base?</h2>
          <p className="text-lg sm:text-xl font-light mb-8">
            Take the first step towards a thriving practice. Let us build a marketing strategy for you.
          </p>
          <button className="bg-white text-blue-600 font-semibold px-10 py-4 rounded-full shadow-lg hover:bg-gray-100 transition-transform transform hover:scale-105">
            Claim Your Free Consultation
          </button>
        </div>
      </section>

      
    </div>
    </Home>
  );
}

export default CampaignLeadGeneration;


